import React, { useEffect, useState } from "react";
import { FaBox, FaBoxes, FaCheck, FaCheckCircle, FaClock, FaEdit, FaHourglassHalf, FaPaperPlane, FaPlusCircle, FaShieldAlt, FaSyncAlt, FaTimesCircle, FaTools, FaTruck, FaWarehouse } from "react-icons/fa";
import { FaRegBuilding, FaRegHospital, FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Card, Col, Container, Row } from "react-bootstrap";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";

const StudyKitPreparationOverview = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const [kitData, setKitData] = useState("");
  const [kitCount, setKitCount] = useState(0);
  const [kitCreatedCount, setKitCreatedCount] = useState(0);
  const [kitInPreparationCount, setKitInPreparationCount] = useState(0);
  const [kitReleasedCount, setKitReleasedCount] = useState(0);
  const [kitReworkCount, setKitReworkCount] = useState(0);
  const [kitPendingQCCount, setKitPendingQCCount] = useState(0);
  const [kitPassedQCCount, setKitPassedQCCount] = useState(0);
  const [kitFailedQCCount, setKitFailedQCCount] = useState(0);
  const [kitAvailableCount, setKitAvailableCount] = useState(0);
  const [kitAllocatedCount, setKitAllocatedCount] = useState(0);
  const [kitQuarantinedCount, setKitQuarantinedCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyKitPreparationOverview = async (e) => {
    setLoading(true);
    let data = await eiwrsKitPreparationServices.getStudyKitPreparationOverview(
      studyId, StudyMode
    );
    setKitCount(data?.count || 0);
    setKitCreatedCount(data?.countCreated || 0);
    setKitInPreparationCount(data?.countInPreparation || 0);
    setKitPendingQCCount(data?.countPendingQC || 0);
    setKitPassedQCCount(data?.countPassedQC || 0);
    setKitFailedQCCount(data?.countFailedQC || 0);
    setKitReleasedCount(data?.countReleased || 0);
    setKitReworkCount(data?.countRework || 0);
    setKitAvailableCount(data?.countAvailable || 0);
    setKitAllocatedCount(data?.countAllocated || 0);
    setKitQuarantinedCount(data?.countQuarantined || 0);
    setLoading(false);
  };

  console.log("kitAllocatedCount", kitAllocatedCount);
  console.log("kitAvailableCount >>>>>>>>", kitAvailableCount);



  useEffect(() => {
    getStudyKitPreparationOverview();
  }, []);

  const overviewCards = [
    {
      title: "Total Kit",
      value: kitCount,
      subtitle: "Total kits configured and tracked in the study",
      icon: <FaBoxes className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Created Kit",
      value: kitCreatedCount,
      subtitle: "Newly created kits awaiting preparation",
      icon: <FaPlusCircle className="bg-white text-info shadow-sm" />,
    },
    {
      title: "In Preparation Kit",
      value: kitInPreparationCount,
      subtitle: "Kits currently being prepared for release",
      icon: <FaTools className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Pending QC Kit",
      value: kitPendingQCCount,
      subtitle: "Kits awaiting quality control review and approval",
      icon: <FaHourglassHalf className="bg-white text-secondary shadow-sm" />,
    },
    {
      title: "Passed QC Kit",
      value: kitPassedQCCount,
      subtitle: "Kits successfully approved after quality checks",
      icon: <FaCheckCircle className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Failed QC Kit",
      value: kitFailedQCCount,
      subtitle: "Kits rejected during quality control inspection",
      icon: <FaTimesCircle className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Released Kit",
      value: kitReleasedCount,
      subtitle: "Kits released for shipment or site allocation",
      icon: <FaPaperPlane className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Rework Kit",
      value: kitReworkCount,
      subtitle: "Kits returned for corrective actions and reprocessing",
      icon: <FaSyncAlt className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Available at Depot",
      value: kitAvailableCount,
      subtitle: "Kits currently available in depot inventory",
      icon: <FaRegHospital className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Allocated at Site",
      value: kitAllocatedCount,
      subtitle: "Kits currently Allocated in site inventory",
      icon: <FaRegBuilding className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Quarantined Kit",
      value: kitQuarantinedCount,
      subtitle: "Kits isolated pending investigation or disposition",
      icon: <FaShieldAlt className="bg-white text-danger shadow-sm" />,
    },
  ];

  return (
    <>
      <div className="overflow-auto" style={{ height: "calc(100vh - 142px)" }}>
        <Container fluid>
          <Row className="g-2 py-2">
            {overviewCards?.map((item, index) => (
              <Col xl={3} lg={4} md={6} sm={12} key={index}>
                <Card className="app-card bg-light border h-100">
                  <Card.Body>
                    <div className="d-flex gap-3">
                      <div className="study_icopn">
                        {item.icon}
                      </div>
                      <div>
                        <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                        <Card.Text className="m-0">{item.value || "0"}</Card.Text>
                        <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default StudyKitPreparationOverview;
